"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onCreate: function() {
          this.state = {
              action: false
            };
        },
        onAction: function(action) {
          this.state.action = action;
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/IssuedCertificate.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_CertImage = require("~/../public/images/icons/certificate.png"),
    CertImage = module_CertImage.default || module_CertImage,
    Image_template = require("../../components/Image/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Image_tag = marko_loadTag(Image_template),
    Locale_template = require("../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Row_template = require("../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Extension_template = require("../../components/Extension/index.marko"),
    Extension_tag = marko_loadTag(Extension_template),
    WSAdapt_template = require("../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    marko_attrs0 = {
        "class": "py-1"
      },
    marko_attrs1 = {
        "class": "col"
      },
    marko_attrs2 = {
        "class": "btn btn-outline-light btn-block"
      },
    marko_attrs3 = {
        "class": "col"
      },
    marko_attrs4 = {
        "class": "btn btn-outline-light btn-block"
      },
    marko_attrs5 = {
        "class": "position-fixed zindex-3 w-100 h-100 top-0 left-0 d-flex align-items-center center"
      },
    marko_attrs6 = {
        "class": "position-fixed top-0 w-100 h-100 theme-bg-transparent animated fadeIn faster"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", null, "0", component);

  Image_tag({
      alt: "Image",
      src: CertImage,
      class: "img-fluid p-2"
    }, out, __component, "1");

  out.be("div", marko_attrs0, "2", component);

  Row_tag({
      class: "no-gutters",
      renderBody: function(out) {
        if (input.actions.includes("view")) {
          out.be("div", marko_attrs1, "4", component);

          out.be("button", marko_attrs2, "5", component, null, 0, {
              onclick: __component.d("click", "onAction", false, [
                  "view"
                ])
            });

          Locale_tag({
              text: "View"
            }, out, __component, "6");

          out.ee();

          out.ee();
        }

        if (input.actions.includes("download")) {
          out.be("div", marko_attrs3, "7", component);

          out.be("button", marko_attrs4, "8", component, null, 0, {
              onclick: __component.d("click", "onAction", false, [
                  "download"
                ])
            });

          Locale_tag({
              text: "Download"
            }, out, __component, "9");

          out.ee();

          out.ee();
        }
      }
    }, out, __component, "3");

  out.ee();

  out.ee();

  if (state.action) {
    out.be("div", marko_attrs5, "10", component);

    Row_tag({
        class: "m-0 w-100 d-flex justify-content-center",
        renderBody: function(out) {
          out.e("div", marko_attrs6, "12", component, 0, 0, {
              onclick: __component.d("click", "onAction", false, [
                  false
                ])
            });

          WSAdapt_tag({
              ns: "col-md-9 col-12",
              qs: "col-md-9 col-12",
              hs: "col-md-10 col-12",
              renderBody: function(out) {
                Extension_tag({
                    name: "XCredible",
                    payload: { 
                      issueData: input.certificate,
                      ...(input.certificate.meta.template),
                      action: state.action
                    }
                  }, out, __component, "14", [
                  [
                    "quit",
                    "onAction",
                    false,
                    [
                        false
                      ]
                  ]
                ]);
              }
            }, out, __component, "13");
        }
      }, out, __component, "11");

    out.ee();
  }
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
